module.exports = __webpack_public_path__ + "static/media/thumbnail.7dec9429.jpg";